export function checkcompat(compound1, compound2) {
  console.log({ compound1, compound2 })
  if (compound1.startsWith(1)) {
    compound1 = '1'
  }
  if (compound2.startsWith(1)) {
    compound2 = '1'
  }
  // console.log({keys: Object.keys(compatibilidad[compound1]), compatibilidad})
    if (Object.keys(compatibilidad[compound1]).includes(compound2)){
        return compatibilidad[compound1][compound2]
    } else {
        return compatibilidad[compound2][compound1] 
    }
}

export const compatibilidad = {
  "1": {
    "1": { color: "yellow", text: "1" },
    "2.1": { color: "red", text: "" },
    "2.2": { color: "red", text: "" },
    "2.3": { color: "red", text: "" },
    "3": { color: "red", text: "" },
    "4.1": { color: "red", text: "" },
    "4.2": { color: "red", text: "" },
    "4.3": { color: "red", text: "" },
    "5.1": { color: "red", text: "" },
    "5.2": { color: "red", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "red", text: "" },
    "7B": { color: "red", text: "" },
    "7C": { color: "red", text: "" },
    "7E": { color: "red", text: "" },
    "8": { color: "red", text: "" },
    "9": { color: "red", text: "" },
    "9A": { color: "red", text: "" },
  },
  "2.1": {
    "2.1": { color: "green", text: "" },
    "2.2": { color: "yellow", text: "segregar >=3m" },
    "2.3": { color: "yellow", text: "segregar >=3m" },
    "3": { color: "red", text: "" },
    "4.1": { color: "red", text: "" },
    "4.2": { color: "red", text: "" },
    "4.3": { color: "red", text: "" },
    "5.1": { color: "red", text: "" },
    "5.2": { color: "red", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "red", text: "" },
    "7B": { color: "red", text: "" },
    "7C": { color: "red", text: "" },
    "7E": { color: "red", text: "" },
    "8": { color: "red", text: "" },
    "9": { color: "red", text: "" },
    "9A": { color: "red", text: "" },
  },
  "2.2": {
    "2.2": { color: "green", text: "" },
    "2.3": { color: "green", text: "segregar >=3m" },
    "3": { color: "yellow", text: "" },
    "4.1": { color: "yellow", text: "" },
    "4.2": { color: "yellow", text: "" },
    "4.3": { color: "yellow", text: "" },
    "5.1": { color: "yellow", text: "" },
    "5.2": { color: "yellow", text: "" },
    "6.1": { color: "yellow", text: "" },
    "7A": { color: "yellow", text: "" },
    "7B": { color: "yellow", text: "" },
    "7C": { color: "yellow", text: "" },
    "7E": { color: "yellow", text: "" },
    "8": { color: "yellow", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "2.3": {
    "2.3": { color: "green", text: "" },
    "3": { color: "red", text: "" },
    "4.1": { color: "red", text: "" },
    "4.2": { color: "red", text: "" },
    "4.3": { color: "red", text: "" },
    "5.1": { color: "red", text: "" },
    "5.2": { color: "red", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "yellow", text: "" },
    "7B": { color: "yellow", text: "" },
    "7C": { color: "yellow", text: "" },
    "7E": { color: "yellow", text: "" },
    "8": { color: "yellow", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "3": {
    "3": { color: "green", text: "" },
    "4.1": { color: "yellow", text: "" },
    "4.2": { color: "yellow", text: "" },
    "4.3": { color: "yellow", text: "" },
    "5.1": { color: "red", text: "" },
    "5.2": { color: "red", text: "" },
    "6.1": { color: "green", text: "" },
    "7A": { color: "yellow", text: "" },
    "7B": { color: "yellow", text: "" },
    "7C": { color: "yellow", text: "" },
    "7D": { color: "yellow", text: "" },
    "8": { color: "yellow", text: "4" },
    "9": { color: "yellow", text: "2" },
    "9A": { color: "yellow", text: "2" },
  },
  "4.1": {
    "4.1": { color: "yellow", text: "" },
    "4.2": { color: "red", text: "" },
    "4.3": { color: "yellow", text: "3" },
    "5.1": { color: "red", text: "" },
    "5.2": { color: "yellow", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "red", text: "" },
    "7B": { color: "red", text: "" },
    "7C": { color: "red", text: "" },
    "7E": { color: "red", text: "" },
    "8": { color: "yellow", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "4.2": {
    "4.2": { color: "green", text: "" },
    "4.3": { color: "yellow", text: "3" },
    "5.1": { color: "red", text: "" },
    "5.2": { color: "red", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "yellow", text: "" },
    "7B": { color: "yellow", text: "" },
    "7C": { color: "yellow", text: "" },
    "7E": { color: "yellow", text: "" },
    "8": { color: "yellow", text: "3" },
    "9": { color: "yellow", text: "3" },
    "9A": { color: "yellow", text: "3" },
  },
  "4.3": {
    "4.3": { color: "green", text: "" },
    "5.1": { color: "red", text: "" },
    "5.2": { color: "red", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "yellow", text: "" },
    "7B": { color: "yellow", text: "" },
    "7C": { color: "yellow", text: "" },
    "7D": { color: "yellow", text: "" },
    "8": { color: "yellow", text: "3" },
    "9": { color: "yellow", text: "3" },
    "9A": { color: "yellow", text: "3" },
  },
  "5.1": {
    "5.1": { color: "yellow", text: "" },
    "5.2": { color: "red", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "red", text: "" },
    "7B": { color: "red", text: "" },
    "7C": { color: "red", text: "" },
    "7E": { color: "red", text: "" },
    "8": { color: "red", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "5.2": {
    "5.2": { color: "yellow", text: "" },
    "6.1": { color: "red", text: "" },
    "7A": { color: "red", text: "" },
    "7B": { color: "red", text: "" },
    "7C": { color: "red", text: "" },
    "7E": { color: "red", text: "" },
    "8": { color: "red", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "6.1": {
    "6.1": { color: "green", text: "" },
    "7A": { color: "yellow", text: "" },
    "7B": { color: "yellow", text: "" },
    "7C": { color: "yellow", text: "" },
    "7E": { color: "yellow", text: "" },
    "8": { color: "green", text: "" },
    "9": { color: "yellow", text: "2" },
    "9A": { color: "yellow", text: "2" },
  },
  "7A": {
    "7A": { color: "green", text: "" },
    "7B": { color: "green", text: "" },
    "7C": { color: "green", text: "" },
    "7E": { color: "green", text: "" },
    "8": { color: "yellow", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "7B": {
    "7B": { color: "green", text: "" },
    "7C": { color: "green", text: "" },
    "7E": { color: "green", text: "" },
    "8": { color: "yellow", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "7C": {
    "7C": { color: "green", text: "" },
    "7E": { color: "green", text: "" },
    "8": { color: "yellow", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "7E": {
    "7E": { color: "green", text: "" },
    "8": { color: "yellow", text: "" },
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "8": {
    "8": { color: "yellow", text: "" },
    "9": { color: "green", text: "" },
    "9A": { color: "green", text: "" },
  },
  "9": {
    "9": { color: "yellow", text: "" },
    "9A": { color: "yellow", text: "" },
  },
  "9A": {
    "9A": { color: "yellow", text: "" },
  },
};
